import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import "../../../../../../formLayout.scss";
import { Link, Box, Button, Modal } from "@mui/material";

import RKTextField from "../../../../../../Supporting files/RKTextField/RKTextField";
import { AccessLevelDTO } from "../../../../../../Services/DTO/Settings/AccessLevel/AccessLevelDTO";
import ModulePermissionAccessControl from "../../../../../../Components/Broker/ModulePermissionAccessControl/ModulePermissionAccessControl";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

function CreateRole() {
  const navigate = useNavigate();
  const [roleName, setRoleName] = React.useState("");
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("roleInformation");
  const [subSection, setSubSection] = React.useState<string>("rolename");
  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  const roleInformation = useRef(null);
  const rolename = useRef(null);
  const modulePermission = useRef(null);

  const scrollToSection = (elementRef: any) => {
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate(-1);
            }}
          >
            <ChevronLeftIcon />
          </Link>

          <div>
            <h3>Create New Role</h3>
          </div>
        </Grid>
        <Grid xs={6}></Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection">
              <Link
                className={
                  sectionStatus === "roleInformation"
                    ? "active sectionLink roleInformation"
                    : "sectionLink roleInformation"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(roleInformation);
                  SetSectionStatus("roleInformation");
                }}
              >
                <span> Role Information</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "rolename"
                        ? "inner_link active rolename"
                        : "inner_link  rolename"
                    }
                    onClick={() => {
                      handleClicks(subSection);
                      scrollToSection(rolename);
                      setSubSection("rolename");
                    }}
                  >
                    Role Name
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      subSection === "modulePermission"
                        ? "inner_link active modulePermission"
                        : "inner_link modulePermission"
                    }
                    onClick={() => {
                      setSubSection("modulePermission");
                      handleClicks(subSection);
                      scrollToSection(modulePermission);
                    }}
                  >
                    Module Permission
                  </Link>
                </li>
              </ul>
            </Grid>
            <Grid xs className="rightSection">
              <Box className="detailSection" ref={roleInformation}>
                <div ref={rolename}>
                  <div className="sectionTitle">
                    <h4>Role Name</h4>
                  </div>
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <h5 className="subHeading">Role Name</h5>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <RKTextField
                        class_name="inputField"
                        title={"Role Name"}
                        value={roleName}
                        attrName={setRoleName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div ref={modulePermission}>
                  <ModulePermissionAccessControl />
                </div>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Footer Section */}
      <Grid container spacing={3} className="footerSection">
        <Grid xs={12} className="ctaBtn">
          <Button variant="outlined" className="borderBtn">
            Cancel
          </Button>

          <Button
            variant="contained"
            className="submitBtn"
            onClick={() => {
              navigate(-1);
            }}
          >
            Save
          </Button>
        </Grid>
      </Grid>

      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are about to Delete this Attatchment.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
}

export default CreateRole;
